export const ja = {
  meta: {
    siteName: 'Focus Cafe',
    lpTitle: 'Focus Cafe｜みんなで集中できる Web のポモドーロタイマー',
    lpDescription:
      'いま集中している人たちと同じカフェで作業できる、Web のポモドーロタイマーです。資格の勉強や受験、英語の学習、試験前の追い込み、エンジニアの開発や仕事の作業に。25分のタイマーをはじめると、あなたも席について集中します。登録なしで、ゲストのまま入れます。',
    lpKeywords: [
      'Web タイマー',
      'ポモドーロタイマー',
      '作業タイマー',
      '勉強',
      '仕事',
      'エンジニア',
      '資格',
      '受験',
      '英語',
      '試験',
      'オンライン自習室',
    ],
    cafeTitle: '店内｜Focus Cafe',
    cafeDescription:
      'Web のポモドーロタイマーをはじめて、自分の席で集中する。勉強も仕事も、いま集中している人たちと同じ店内で。',
    profileTitle: '{name} の作業記録｜Focus Cafe',
    profileDescription: '{name} さんは Focus Cafe で累計 {total} 集中しています。',
    logTitle: '{name} の {minutes}分｜Focus Cafe',
    logDescription: '{date}、{name} さんが Focus Cafe で {minutes}分 集中しました。',
    termsTitle: '利用規約｜Focus Cafe',
    privacyTitle: 'プライバシーポリシー｜Focus Cafe',
    notFoundTitle: 'ページが見つかりません｜Focus Cafe',
    meTitle: 'マイページ｜Focus Cafe',
    rankingTitle: '累計集中時間ランキング｜Focus Cafe',
    rankingDescription: 'Focus Cafe で集中した時間の累計が長い、上位{n}人の常連さんです。',
    pomodoroTitle: 'ポモドーロ・テクニックとは？やり方と続けるコツ｜Focus Cafe',
    notificationsTitle: '通知｜Focus Cafe',
  },
  nav: {
    home: 'ホーム',
    enter: '店内へ',
    signOut: 'ログアウト',
    profile: 'マイページ',
    terms: '利用規約',
    privacy: 'プライバシー',
    language: '言語',
    skipToContent: '本文へ移動',
    ranking: 'ランキング',
    pomodoro: 'ポモドーロとは',
    notifications: '通知',
  },
  lp: {
    eyebrow: 'オンライン・コワーキングカフェ',
    heroLine1: '誰かのとなりで、',
    heroLine2: '集中する。',
    heroLead:
      'いま集中している人が、カフェの席に座っています。タイマーをはじめると、あなたも空いている席について集中できます。',
    cta: '店に入る',
    ctaNote: '登録不要。ゲストのまま入れます',
    liveNow: 'いま {n}人 が集中しています',
    liveQuiet: 'いまは静かな時間です。最初のひとりになりませんか',
    starsToday: '今日の星 {n}',
    livePresent: '入店中',
    liveFocusing: '集中している人',
    timePick: '時間帯を選ぶ',
    scrollHint: 'スクロール',
    stepsTitle: '一杯ぶんの集中を',
    steps: [
      {
        title: '席に着く',
        body: 'Google アカウントか、ゲストのまま入店します。48 の席のどこかに、あなたの席が用意されます。',
      },
      {
        title: '集中する',
        body: '25分・50分・90分から選んでタイマーをはじめると、あなたが席について、手元のランプが点きます。',
      },
      {
        title: '星になる',
        body: '時間が満ちると、カップの湯気が光の粒になって窓の外へ昇り、夜空の星がひとつ増えます。',
      },
    ],
    receiptTitle: '一杯ごとに、レシートを',
    receiptBody:
      '終わったら、やったことをひとこと残せます。日付と集中時間、メモ、あなたの席のランプを印字したレシートが届きます。そのまま SNS に貼れます。',
    timeTitle: '店は、空と一緒に表情を変える',
    timeBody:
      '朝は湖を覆う霧、昼は空を映す水鏡、夕方は山の端に沈む陽、夜は湖に落ちる天の川。あなたのいる時刻の店が開いています。',
    times: { morning: '朝', day: '昼', evening: '夕方', night: '夜' },
    usesTitle: '勉強にも、仕事にも',
    usesLead:
      'ブラウザで開くだけの Web のポモドーロタイマーです。インストールはいりません。ひとりだと手が止まる作業を、誰かのとなりで進められます。',
    uses: [
      { title: '資格・受験の勉強', body: '過去問を一題ずつ、25分ごとに区切って進める。' },
      { title: '英語の学習', body: '単語、リスニング、シャドーイング。毎日少しずつ積み上げる。' },
      { title: '試験前の追い込み', body: '50分・90分の長めのタイマーで、範囲をまとめて片づける。' },
      { title: 'エンジニアの開発作業', body: '実装や技術書の読書に。通知を閉じて、一杯ぶんだけ没頭する。' },
      { title: '仕事の作業', body: '資料づくりやメールの返信も、時間を決めて終わらせる。' },
    ],
    closingTitle: '今日も、一杯ぶん集中する。',
    sampleNote: '設計書の第3章を書き終えた。明日はテスト。',
    closingCta: '店に入る',
  },
  auth: {
    boardTitle: 'いらっしゃいませ',
    boardLead: '席にご案内します',
    google: 'Google で入店',
    guest: 'ゲストで入る',
    guestNote: 'ゲストの記録はこのブラウザに紐づきます。あとから Google と連携すると引き継げます。',
    linkGoogle: 'Google と連携して記録を残す',
    agree: '入店すると {terms} と {privacy} に同意したものとみなします。',
    signingIn: '案内しています…',
    failed: 'ログインできませんでした。もう一度お試しください。',
  },
  account: {
    nameTitle: '表示名を決める',
    nameLead: '店内の一覧やレシートに出す名前を決めてください。Google アカウントの名前は表示されません。',
    nameLabel: '表示名',
    namePlaceholder: '例）よるのねこ',
    nameHint: '他の人に見える名前です。あとからマイページで変更できます。',
    nameSubmit: 'この名前で入店する',
    nameInvalid: '1〜{max}文字で入力してください（改行や制御文字は使えません）',
    nameFailed: '保存できませんでした。もう一度お試しください。',
    saving: '保存しています…',
    save: '変更を保存',
    saved: '表示名を変更しました',
    title: 'マイページ',
    guestNote: 'ゲストの記録はこのブラウザだけに残り、公開ページはありません。',
    publicProfile: '公開プロフィールを見る',
    editName: '表示名を変更する',
    signedOut: 'ログインしていません。店内に入るとマイページを使えます。',
    backToCafe: '店内へ戻る',
  },
  cafe: {
    menuTitle: '本日のメニュー',
    focusing: '集中',
    resting: '休憩',
    focusingCount: '集中している人',
    starsCount: '今日の星',
    terrace: 'テラス席 {n}人',
    presentCount: '入店中',
    present: '席にいる人',
    nobody: 'まだ誰もいません',
    you: 'あなた',
    timerLabel: 'タイマー',
    presets: '時間を選ぶ',
    presetOption: '{focus}分 集中 / {rest}分 休憩',
    customPreset: '自分で決める',
    customFocus: '集中（分）',
    customRest: '休憩（分）',
    customHint: '集中は1〜{focusMax}分、休憩は1〜{restMax}分で決められます',
    motionOff: 'アニメーションを止める（動作を軽くする）',
    start: '集中する',
    cancel: 'やめる',
    cancelConfirm: '途中でやめると、この回は記録されません',
    focusPhase: '集中',
    restPhase: '休憩',
    restStart: '休憩する',
    skipRest: '休憩を終える',
    remaining: '残り時間',
    reconnecting: '店とつながり直しています…',
    viewerNote: '入店すると、あなたも席について集中できます',
    terraceSeat: '店内が満席のため、テラス席にいます',
    seatLabel: '{n}番席',
    completeTitle: 'おつかれさまでした',
    completeLead: '{minutes}分、集中しました。やったことをひとこと残しませんか。',
    notePlaceholder: '例）設計書の第3章を書き終えた',
    notePublic:
      'このメモはレシートに印字され、公開ページに載ります。誰でも見られるので、個人情報は書かないでください。',
    notePublicGuest:
      'このメモはレシートに印字されます。Google と連携すると公開ページに載るので、個人情報は書かないでください。',
    noteCounter: '{n}/{max}',
    save: 'レシートを受け取る',
    saving: '印字しています…',
    skipNote: '記録して休憩へ',
    saveFailed: '記録できませんでした。通信を確認してもう一度お試しください。',
    shareFailed: '共有できませんでした。画像を保存してから投稿してください。',
    receiptTitle: 'レシート',
    shareX: 'X でシェア',
    shareNative: '共有',
    download: '画像を保存',
    shareText: 'Focus Cafe で {minutes}分 集中しました',
    toRest: '休憩に入る',
    focusAgain: '休憩せずに続けて集中する',
    guestShareNote: 'Google と連携すると、レシートの公開 URL を持てます',
    nowPlaying: 'BGM',
    receiptsTitle: 'みんなのレシート',
    like: 'いいね',
    unlike: 'いいねを取り消す',
    likeNeedsEntry: '入店するといいねできます',
  },
  chat: {
    title: '休憩中のおしゃべり',
    empty: 'まだ誰も話していません。休憩中の人に話しかけてみましょう',
    inputLabel: 'ひとこと',
    placeholder: '休憩中の人に話しかける',
    send: '送る',
    delete: '消す',
    counter: '{n}/{max}',
    guestNote: 'Google と連携すると、休憩中の人と話せます',
    link: 'Google と連携する',
  },
  receipt: {
    shop: 'FOCUS CAFE',
    tagline: 'A café lit by focus',
    date: '日付',
    time: '時間',
    focus: '集中',
    seat: '席',
    terrace: 'テラス',
    guest: 'ゲスト',
    note: 'メモ',
    total: '合計',
    thanks: 'またのご来店をお待ちしております',
    stamp: '済',
    item: '集中 {minutes}分',
  },
  profile: {
    totalTime: '累計',
    streak: '連続',
    streakDays: '{n}日',
    sessions: 'セッション',
    sessionsCount: '{n}杯',
    heatmapTitle: '最近の集中',
    heatmapCell: '{date}：{duration}',
    heatmapLess: '少',
    heatmapMore: '多',
    recentTitle: '最近のレシート',
    noLogs: 'まだレシートがありません',
    since: '{date} から来店',
    deleteLog: 'このレシートを消す',
    deleteConfirm: 'このレシートを消しますか？ この回の集中時間も累計から差し引かれ、元に戻せません。',
    deleteFailed: 'レシートを消せませんでした。時間をおいてもう一度お試しください。',
  },
  ranking: {
    title: '累計ランキング',
    lead: 'これまでに集中した時間の累計が長い順に、上位{n}人を並べています。',
    empty: 'まだ誰も集中していません',
    rank: '{n}位',
  },
  notifications: {
    title: '通知',
    empty: 'まだ通知はありません。あなたのレシートにいいねが付くと、ここに届きます。',
    liked: '{name} さんが {receipt} のレシートにいいねしています',
    receipt: '{date}・{duration}',
    signedOut: 'ログインしていません。店内に入ると通知を受け取れます。',
    guestNote: 'ゲストのレシートは公開されないので、いいねは届きません。Google と連携すると受け取れます。',
    new: '新着',
  },
  log: {
    by: '{name} さんのレシート',
    viewProfile: '{name} さんの記録を見る',
    cta: 'あなたも集中する',
  },
  legal: {
    updated: '最終更新日：{date}',
    back: 'ホームに戻る',
    /** 規約を英語版で出す言語のための注記。ja と en では出さない */
    englishOnly: '',
  },
  duration: { minutes: '{m}分', hours: '{h}時間', hoursMinutes: '{h}時間{m}分' },
  notFound: {
    title: 'この席は空いていません',
    body: 'お探しのページは見つかりませんでした。',
    back: 'ホームに戻る',
  },
  error: {
    title: 'ただいま準備中です',
    body: '一時的に表示できませんでした。少し時間をおいてお試しください。',
    retry: 'もう一度試す',
  },
}
